/* eslint-disable import/prefer-default-export */
/* eslint-disable no-use-before-define */
import get from 'lodash/get';
import { isP4b } from '../actions/components';
import FSM_CONSTANTS from '../components/fseManagementSystem/utils/FSMContants';
/**
 *
 * @param {*} localStorageData
 */
export function initializeHawkeye(localStorageData) {
  const script = document.createElement('script');
  script.src =
    'https://webappsstatic.paytm.com/hawkeyeweb/hawkeye_1.3.0.min.js';
  script.defer = true;
  script.crossOrigin = 'anonymous';
  script.onload = function () {
    const userId =
      get(localStorageData, 'custId', null) ||
      get(localStorageData, 'pgMid', null);
    window.Hawkeye.configure({
      env: process.env.REACT_APP_ENV,
      logAPIs: false,
      logNetworkError: false,
      logJSError: true,
      logPerformance: true,
      verticalName: isP4b()
        ? FSM_CONSTANTS.FSM_P4B_Attendance
        : FSM_CONSTANTS.FSM_GG_APP,
      mid: userId,
    });
    console.log('Hawkeye configured');
    setUserInHawkeye(localStorageData);
  };
  document.head.appendChild(script);
}

/**
 * @param {*} localStorageData
 */
function setUserInHawkeye(localStorageData) {
  const userId =
    get(localStorageData, 'custId', null) ||
    get(localStorageData, 'pgMid', null);
  try {
    if (userId) {
      window.Hawkeye.reconfigure((config) => {
        console.log('hawkeye reconfigured', JSON.stringify(config));
        return { ...config, mid: userId };
      });
    }
  } catch (error) {
    if (!window.Hawkeye) {
      console.log('hawkeye catch', userId);
    }
    console.warn('Unable to set user in Hawkeye correctly');
  }
}
